import React from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { useAuth ,AuthProvider} from './context/Authcontext';
import ListingsPage from "./pages/ListingsPage";
import HomePage from "./pages/HomePage";
// import Prices from "./pages/Prices";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ResetPassword from "./pages/ResetPassword";
import ManageSubscription from "./pages/ManageSubscription";
import DataStatsPage from "./pages/DataStatsPage";


const ProtectedRoute = ({ children }) => {
    const { isAuthenticated,loading} = useAuth();
    if (loading){
      return <div>Loading...</div>;
    }
    return isAuthenticated ? children : <Navigate to="/login" />;
  };
  const ProjectRoutes = () => {
    return (
        <BrowserRouter>
        <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/" element={<ProtectedRoute><DataStatsPage /></ProtectedRoute>} /> */}
          <Route path="/listings"       element={<ProtectedRoute><ListingsPage/></ProtectedRoute>} />
          {/* <Route path="/prices"         element={<Prices />} /> */}
          <Route path="/login"          element={<Login />} />
          <Route path="/signup"         element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/manage-subscription" element={<ProtectedRoute><ManageSubscription /></ProtectedRoute>} />
          <Route path="/datastats" element={<ProtectedRoute><DataStatsPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route
  path="/test-protected"
  element={
    <ProtectedRoute>
      <div>Protected Content</div>
    </ProtectedRoute>
  }
/>
        </Routes>
        </AuthProvider>
      </BrowserRouter>
    );
}
export default ProjectRoutes;